import { Link } from 'react-router-dom';
import { formatDuration } from '../../features/pilotMath/format';
import { pilotSummary } from '../../features/pilotMath/store';
import { usePilotState } from '../../features/pilotMath/usePilotState';

export function StudentDashboard() {
  const [state] = usePilotState();
  const summary = pilotSummary(state);
  const current = state.questions[state.currentIndex];

  return (
    <div className="stack">
      <div><h1>Halo, {state.student.displayName} 👋</h1><p className="muted">Belajar Hari Ini</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>Matematika</span><strong>{summary.completed}/{summary.totalQuestions}</strong><span className="muted">soal pilot</span></div>
        <div className="metric"><span>First-attempt</span><strong>{summary.firstAttemptAccuracy}%</strong><span className="muted">hari ini</span></div>
        <div className="metric"><span>Waktu aktif</span><strong>{formatDuration(summary.totalActiveMs)}</strong><span className="muted">bukan idle time</span></div>
      </section>
      <section className="card hero-card">
        <div className="eyebrow">PILOT-01A · Daily Math Runtime</div>
        <h2>{state.status === 'completed' ? 'Belajar matematika hari ini selesai' : 'Matematika siap dikerjakan'}</h2>
        <p>{state.status === 'completed' ? 'History, koreksi, waktu aktif, dan evidence skill sudah tersimpan pada pilot browser.' : current ? `${current.skillLabel} · ${current.reasonCode.replaceAll('_', ' ')}` : 'Daily plan siap.'}</p>
        <div className="button-row">
          {state.status !== 'completed' && <Link className="btn btn--primary" to="/student/today">{state.status === 'in_progress' ? 'Lanjutkan belajar' : 'Mulai belajar'}</Link>}
          <Link className="btn" to="/student/progress">Lihat progress</Link>
        </div>
      </section>
      <section className="card"><h2>Subjek lain</h2><p className="muted">English, Bahasa Indonesia, Bahasa Arab, IPA, dan IPS tetap berada pada roadmap. Pilot runtime sengaja dibatasi pada Matematika agar alur adaptif dapat divalidasi terlebih dahulu.</p></section>
    </div>
  );
}
